import { render, staticRenderFns } from "./OtherRecordOut.vue?vue&type=template&id=413ebbac&scoped=true"
import script from "./OtherRecordOut.vue?vue&type=script&lang=js"
export * from "./OtherRecordOut.vue?vue&type=script&lang=js"
import style0 from "./OtherRecordOut.vue?vue&type=style&index=0&id=413ebbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413ebbac",
  null
  
)

export default component.exports